import { Handle, Position } from '@xyflow/react';
import type { CSSProperties, FunctionComponent } from 'react';
import { useCallback } from 'react';
import { NodeHandlerId } from '../../types/node-handler-id';

interface IProps {
    isConnectorNode: boolean;
    usedHandles: NodeHandlerId[];
}

export const NodeHandlers: FunctionComponent<IProps> = ({ isConnectorNode, usedHandles }) => {
    const getHandleStyles = useCallback(
        (side: string): CSSProperties => ({
            width: isConnectorNode ? '7px' : '5px',
            height: isConnectorNode ? '7px' : '5px',
            ...(side === 'top' ? { top: -5 } : undefined),
            ...(side === 'right' ? { right: -5 } : undefined),
            ...(side === 'left' ? { left: -5 } : undefined),
            ...(side === 'bottom' ? { bottom: -5 } : undefined),
        }),
        [isConnectorNode],
    );

    return (
        <>
            {usedHandles.includes(NodeHandlerId.SOURCE_TOP) ? (
                <Handle id={NodeHandlerId.SOURCE_TOP} type="source" position={Position.Top} style={{ ...getHandleStyles('top') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.SOURCE_RIGHT) ? (
                <Handle id={NodeHandlerId.SOURCE_RIGHT} type="source" position={Position.Right} style={{ ...getHandleStyles('right') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.SOURCE_BOTTOM) ? (
                <Handle id={NodeHandlerId.SOURCE_BOTTOM} type="source" position={Position.Bottom} style={{ ...getHandleStyles('bottom') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.SOURCE_LEFT) ? (
                <Handle id={NodeHandlerId.SOURCE_LEFT} type="source" position={Position.Left} style={{ ...getHandleStyles('left') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.TARGET_TOP) ? (
                <Handle id={NodeHandlerId.TARGET_TOP} type="target" position={Position.Top} style={{ ...getHandleStyles('top') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.TARGET_RIGHT) ? (
                <Handle id={NodeHandlerId.TARGET_RIGHT} type="target" position={Position.Right} style={{ ...getHandleStyles('right') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.TARGET_BOTTOM) ? (
                <Handle id={NodeHandlerId.TARGET_BOTTOM} type="target" position={Position.Bottom} style={{ ...getHandleStyles('bottom') }} />
            ) : null}
            {usedHandles.includes(NodeHandlerId.TARGET_LEFT) ? (
                <Handle id={NodeHandlerId.TARGET_LEFT} type="target" position={Position.Left} style={{ ...getHandleStyles('left') }} />
            ) : null}
        </>
    );
};
